import { Component, OnInit } from '@angular/core';
import { Subscription, Subject, BehaviorSubject } from 'rxjs';
import { UscStoreService } from '../../services/usc-store/usc-store.service';
import { AdminService, ApiService, AuthService, CalendarService, ConditionService, DialogService, FieldService, FormulaService, MetadataService, ModalService, SessionService, TranslatorService } from '../../services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { UscStoreMobileService } from '../../services/usc-store-mobile/usc-store-mobile-service';

@Component({
    selector: 'sn-usc-store-mobile',
    templateUrl: './usc-store-mobile.component.html',
    styleUrls: ['./usc-store-mobile.component.css']
})
export class UscStoreMobileComponent implements OnInit {

    metaDataSub: Subscription;
    getConsultantSalesQuotaAchievementsSub: Subscription;
    getConsultantSalesGoalAchievementsSub: Subscription;
    getTodaysConsultantSalesGoalAchievementsSub: Subscription;
    getStoreSalesQuotaAchievementsSub: Subscription;
    getStoreTodaysSalesQuotaAchievementsSub: Subscription;

    constructor(
        public router: Router,
        public ngbModal: NgbModal,
        public modalService: ModalService,
        public adminService: AdminService,
        public metadataService: MetadataService,
        public authService: AuthService,
        public apiService: ApiService,
        public sessionService: SessionService,
        public conditionService: ConditionService,
        public uscStoreService: UscStoreService,
        public calendarService: CalendarService,
        public translatorService: TranslatorService,
        public fieldService: FieldService,
        public formulaService: FormulaService,
        public dialogService: DialogService,
        public uscStoreMobileService: UscStoreMobileService
    ) {
    }

    public p2w_achievement_initialized:boolean = false;
    ngOnInit() {
        this.authService.authenticatedUser.subscribe(u => {
            if (u && u.ID) {
                this.uscStoreMobileService.initializeMobileSession(u);
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-mobile/usc-store-mobile.component.ts